import { render, staticRenderFns } from "./dc-vizlet.vue?vue&type=template&id=4928d9e4&scoped=true&"
import script from "./dc-vizlet.vue?vue&type=script&lang=js&"
export * from "./dc-vizlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4928d9e4",
  null
  
)

export default component.exports